import { render } from "./FormView.vue?vue&type=template&id=70b061a4"
import script from "./FormView.vue?vue&type=script&lang=js"
export * from "./FormView.vue?vue&type=script&lang=js"

import "@/assets/css/views/FormView.scss?vue&type=style&index=0&lang=scss"
import "@/assets/css/SecondaryButton.scss?vue&type=style&index=1&lang=scss"
import "@/assets/css/ConfirmButton.scss?vue&type=style&index=2&lang=scss"

import exportComponent from "/builds/legand/anomyma/commerce-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__